import { EmployeeTypes, Genders } from "../add-employee/steps/Employee";

export const AUTOMATION_ELEMENT = {
  TRIGGER: "Trigger",
  ACTION: "Action",
};

export const AUTOMATION_TRIGGERS = {
  CAMPAIGN_PUBLISHED: "CAMPAIGN_PUBLISHED",
  FORM_SUBMITTED: "FORM_SUBMITTED",
  CONTACT_ADDED: "CONTACT_ADDED",
  VALUE_CHANGED: "CONTACT_UPDATED",
  PEOPLE_DEAL_WON: "PEOPLE_DEAL_WON",
  PEOPLE_CANDIDATE_STAGE_CHANGED: "PEOPLE_CANDIDATE_STAGE_CHANGED",
  PEOPLE_INVOICE_CREATED: "PEOPLE_INVOICE_CREATED",
  SEND_EMAIL:"SEND_EMAIL",
  EXPENSE_CREATED: "PEOPLE_EXPENSE_CREATED",
  PEOPLE_LEAVE_CREATED : 'PEOPLE_LEAVE_CREATED',
  PEOPLE_DATE_ALERT : "PEOPLE_DATE_ALERT_TRIGGER",
  PEOPLE_EMPLOYEE_ADDED : "PEOPLE_EMPLOYEE_ADDED"
};

export const AUTOMATION_ACTIONS = {
  SEND_EMAIL: "SEND_EMAIL",
  CREATE_CONTACT: "CREATE_CONTACT",
  UPDATE_CONTACT: "UPDATE_CONTACT",
  CREATE_DEAL: "CREATE_DEAL",
  UPDATE_DEAL: "UPDATE_DEAL",
  SPLIT_WORKFLOW: "SPLIT",
  WAIT_FOR_TIME: "WAIT_FOR_TIME",
  SEND_SMS_MESSAGE: "SEND_SMS_MESSAGE",
  SEND_WHATSAPP_MESSAGE: "SEND_WHATSAPP_MESSAGE",
  ASSIGN_ACCESS: "ASSIGN_ACCESS",
  END_WORKFLOW: "END_WORKFLOW",
  DESIGNATION: "DESIGNATION",
  CALCULATE_COMMISSION: "CALCULATE_COMMISSION",
  COMMISSION_BASED_ON: "COMMISSION_BASED_ON",
  INVOICE_COMMISSION: "INVOICE_COMMISSION",
  SEND_MESSAGE: "SEND_MESSAGE",
  EXPENSE_APPROVAL: "PEOPLE_EXPENSE_APPROVAL",
  LEAVE_APPROVAL: "PEOPLE_LEAVE_APPROVAL",
  APPROVAL_CONDITION: "APPROVAL_CONDITION"
};

export const WAIT_INTERVALS = ["day", "hour", "minute"];

export const SPLIT_ACTION_TYPE = {
  DESIGNATION_CHECK: "DESIGNATION_CHECK",
  DEAL_CHECK: "DEAL_CHECK",
  EMAIL_OPENED: "EMAIL_OPENED",
  EMAIL_LINK_CLICKED: "EMAIL_LINK_CLICKED",
  DESIGNATION: "DESIGNATION",
  COMMISSION_BASED_ON: "COMMISSION_BASED_ON",
};

export const SPLIT_ACTION_TYPE_CONTEXT = {
  [SPLIT_ACTION_TYPE.DESIGNATION_CHECK]: [
    AUTOMATION_ACTIONS.CREATE_CONTACT,
    AUTOMATION_ACTIONS.UPDATE_CONTACT,
    AUTOMATION_TRIGGERS.PEOPLE_DEAL_WON,
    AUTOMATION_TRIGGERS.CONTACT_ADDED,
    AUTOMATION_TRIGGERS.VALUE_CHANGED,
    AUTOMATION_ACTIONS.CALCULATE_COMMISSION,
    AUTOMATION_ACTIONS.DESIGNATION,
    AUTOMATION_ACTIONS.SPLIT_WORKFLOW,
    AUTOMATION_TRIGGERS.PEOPLE_INVOICE_CREATED,
    AUTOMATION_ACTIONS.INVOICE_COMMISSION
  ],
  [SPLIT_ACTION_TYPE.DEAL_CHECK]: [
    AUTOMATION_ACTIONS.CREATE_DEAL,
    AUTOMATION_ACTIONS.UPDATE_DEAL,
  ],
  [SPLIT_ACTION_TYPE.EMAIL_OPENED]: [AUTOMATION_ACTIONS.SEND_EMAIL],
  [SPLIT_ACTION_TYPE.EMAIL_LINK_CLICKED]: [AUTOMATION_ACTIONS.SEND_EMAIL],
  [SPLIT_ACTION_TYPE.DESIGNATION]: [AUTOMATION_ACTIONS.DESIGNATION],
  [SPLIT_ACTION_TYPE.COMMISSION_BASED_ON]: [AUTOMATION_ACTIONS.COMMISSION_BASED_ON],
};

export const OPERATOR_LIST = {
  EQUAL: {
    displayName: "Equals to (==)",
    symbol: "==",
    token: "eq",
  },
  CONTAINS: {
    displayName: "Contains (=>)",
    symbol: "=>",
    token: "c",
  },
  GREATER_EQUAL: {
    displayName: "Greater than Equal (=>)",
    symbol: "=>",
    token: "gteq",
  },
  LESSER_EQUAL: {
    displayName: "Less than Equal (<=)",
    symbol: "<=",
    token: "lteq",
  },
  GREATER: {
    displayName: 'Greater than (>)',
    symbol: '>',
    token: 'gt'
  },
  LESSER: {
    displayName: 'Less than (<)',
    symbol: '<',
    token: 'lt'
  },
};

export const STATUS_OPTIONS = {
  ACTIVE: [1],
  IN_ACTIVE: [2],
};

export const UNSUPPORTED_SPLIT_CONTEXT_ACTIONS = [
  AUTOMATION_ACTIONS.WAIT_FOR_TIME,
  AUTOMATION_ACTIONS.SEND_SMS_MESSAGE,
  AUTOMATION_ACTIONS.SEND_WHATSAPP_MESSAGE,
  AUTOMATION_ACTIONS.ASSIGN_ACCESS,
  AUTOMATION_TRIGGERS.CAMPAIGN_PUBLISHED,
];

export const SUPPORTED_ASSIGN_ACCESS_ELEMENTS = [
  AUTOMATION_TRIGGERS.CONTACT_ADDED,
  AUTOMATION_TRIGGERS.PEOPLE_DEAL_WON,
  AUTOMATION_ACTIONS.CREATE_CONTACT,
  AUTOMATION_ACTIONS.CREATE_DEAL,

  AUTOMATION_TRIGGERS.VALUE_CHANGED,
  AUTOMATION_ACTIONS.UPDATE_CONTACT,
  AUTOMATION_ACTIONS.UPDATE_DEAL,
];

/* Where Child & parent node is to be considered as one */
export const DIRECT_CHILD_ACTION_TYPES = [
  AUTOMATION_ACTIONS.SPLIT_WORKFLOW,
  AUTOMATION_ACTIONS.ASSIGN_ACCESS,
];

/* layout configs for automation elements */
export const SPLIT_GUTTER = 30;
export const STEP_CARD_WIDTH = 250;
export const CONNECTOR_DIMENSION = { width: 3, height: 30 };
export const SPLIT_CONSTANT = {
  flatAmount: 'Flat Amount',
  percentageOfDealCost:'Percentage of Total Cost'
}

export const WORKFLOW_NODE_MAPPING = {
    [AUTOMATION_TRIGGERS.PEOPLE_DEAL_WON]: "d_p_p_deal_won",
    [AUTOMATION_ACTIONS.SPLIT_WORKFLOW]: "crm3_d_s_split",
    [AUTOMATION_ACTIONS.CALCULATE_COMMISSION]: "d_p_p_calculate_commission",
    [AUTOMATION_ACTIONS.INVOICE_COMMISSION]: "d_p_p_invoice_commission",
    [SPLIT_ACTION_TYPE.DESIGNATION_CHECK]: "d_p_p_split_designation_check",
    [AUTOMATION_ACTIONS.DESIGNATION]: "d_p_p_designation_check",
    [AUTOMATION_TRIGGERS.PEOPLE_CANDIDATE_STAGE_CHANGED]: "d_p_p_candidate_stage_changed",
    [AUTOMATION_ACTIONS.SEND_EMAIL]: "crm3_d_s_send_email",
    [AUTOMATION_TRIGGERS.PEOPLE_INVOICE_CREATED]: "d_p_p_invoice_created",
    [AUTOMATION_ACTIONS.EXPENSE_APPROVAL]: "d_p_p_expense_approval",
    [AUTOMATION_ACTIONS.LEAVE_APPROVAL]: "d_p_p_leave_approval",
    [AUTOMATION_ACTIONS.APPROVAL_CONDITION]: "d_p_p_approval_condition",
    [AUTOMATION_TRIGGERS.EXPENSE_CREATED]: "d_p_p_expense_created",
    [AUTOMATION_TRIGGERS.PEOPLE_LEAVE_CREATED]: "d_p_p_leave_created",
    [AUTOMATION_TRIGGERS.PEOPLE_DATE_ALERT]: "d_p_p_date_alert_trigger"
}

export const EMAIL_COMPOSER_DIMENSIONS = { width: 700, height: 600, fieldHeight: 45, editorHeight: 250 };

export const AUTOMATION_TYPES = {
    CALCULATE_COMMISSION: "CALCULATE_COMMISSION",
    INVOICE_COMMISSION: "INVOICE_COMMISSION",
    SEND_EMAIL: "SEND_EMAIL"
}
export const APPROVAL_REQURIED_CONDITION = [
  { id: 'ANY', label: 'any' },
  { id: 'ALL', label: 'all' }
];

export const APPROVAL_TYPES = [
  { id: AUTOMATION_TRIGGERS.PEOPLE_LEAVE_CREATED, label: 'any' },
  { id: AUTOMATION_TRIGGERS.EXPENSE_CREATED, label: 'all' }
];

export const APPROVAL_ACTIONS = {
  [AUTOMATION_TRIGGERS.PEOPLE_LEAVE_CREATED]: 'PEOPLE_LEAVE_CREATED',
  [AUTOMATION_TRIGGERS.EXPENSE_CREATED]: 'PEOPLE_EXPENSE_CREATED'
};
export const DOCUMENTS = [
  { id: 'SALES_INVOICE', name: 'Invoice' },
  { id: 'QUOTATION', name: 'Quote' },
  { id: 'PURCHASE_INVOICE', name: 'Bill' },
  { id: 'PURCHASE_ORDER', name: 'Order' },
  { id: 'REQUISITION', name: 'Requisition' }
];
export const SUPPORTED_APPROVAL_CONDITIONS_ACTIONS = [
  AUTOMATION_TRIGGERS.PEOPLE_LEAVE_CREATED,
  AUTOMATION_TRIGGERS.EXPENSE_CREATED
];

export const DATE_ALERT_CRITERIA = {
    BEFORE : "before",
    ON : "on",
    AFTER : "after"
}

export const FILTER_OPERATORS = {
  EQUAL : "eq",
  NOT_EQUAL : "neq",
  GREATER_THAN : "gt",
  GREATER_THAN_OR_EQUAL : "gte",
  GREATER_EQUAL : "gteq", /* only used in automation for dates */
  LESS_THAN : "lt",
  LESS_THAN_OR_EQUAL : "lte",
  CONTAINS : "c",
  IN : "in"
}

export const FILTER_OPERATORS_NAMES = {
    "eq": "=",
    "gt": ">",
    "gteq": ">=",
    "lt": "<",
    "lteq": "<="
}

export const TRIGGER_ON_CONDITION = {
    ["specificDate"] : "Specific Date",
    ["yearlyBasis"] : "Yearly Basis"
}

export const EMPLOYEE_COLUMNS = [
  {
		id: "name",
		key: "name",
		value: "name",
		name: "Name",
		type: "text",
	},
	{
		id: "designation",
		key: "designation",
		value: "designation",
		name: "Job Title",
		type: "text",
	},
	{
		id: "gender",
		key: "gender",
		value: "gender",
		name: "Gender",
		type: "select",
		options: Genders,
	},
	{
		id: "reportingManagerId",
		key: "reportingManagerId",
		value: "reportingManagerId",
		name: "Reporting Manager",
		type: "select",
		options: [],
	},
	{
		id: "reportingManagerName",
		key: "reportingManagerName",
		value: "reportingManagerName",
		name: "Direct Manager Name",
		type: "text",
	},
	{
		id: "employeeType",
		key: "employeeType",
		value: "employeeType",
		name: "Employment Type",
		type: "select",
		options: EmployeeTypes,
	},
];
